<template class="pa-0">
    <v-card-text>
        <v-layout row wrap class="pa-0">
            <header-text :text="$vuetify.lang.t('$vuetify.address_in_nepal')"
                         icon="description"></header-text>
            <v-flex md6 xs12>
                <address-auto-complete
                    :rules="[rules.required]"
                    class="pr-3"
                    countryCode="np"
                    label="Address in Nepal *"
                    v-model="visa.extra.application_data.address_in_nepal"
                ></address-auto-complete>
            </v-flex>
            <v-flex md6 xs12>
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.contact_no_nepal')"
                    :rules="visa.traveller.contact_no_nepal?[rules.minLength]:[]"
                    outlined
                    type="number"
                    v-model="visa.traveller.contact_no_nepal"
                ></v-text-field>
            </v-flex>
        </v-layout>
    </v-card-text>
</template>

<script>
    import AddressAutoComplete from "../../AddressAutoComplete";
    import {validationMixin} from "../../../mixins/validationMixin";
    import HeaderText from "../../HeaderText";


    export default {
        mixins: [validationMixin],
        components: {
            "address-auto-complete": AddressAutoComplete,
            HeaderText
        },
        computed: {
            visa() {
                return this.$store.state.VisaSingle.visa;
            }
        },

    };
</script>

<style>
</style>
